import i18n from "@/libraries/i18n";
import { HTML_LANG } from "@/libraries/locale-codes";
import { useLocaleShallow } from "@/stores/locale";
import { useEffect } from "react";

/**
 * Applies the current app locale to the pieces of the page that i18next doesn't
 * touch on its own: i18next's active language, and <html lang> (used by screen
 * readers and browser spellcheck/translate prompts - it's hardcoded "en" in
 * index.html otherwise).
 */
const LocaleEffects = () => {
	const locale = useLocaleShallow((state) => state.locale);

	useEffect(() => {
		if (i18n.language !== locale) {
			i18n.changeLanguage(locale);
		}
		document.documentElement.lang = HTML_LANG[locale];
	}, [locale]);

	return null;
};

export default LocaleEffects;
